import { BaseService } from 'hungry-core2'

import actions from '@actions'

export default class LoadingIndicator extends BaseService {
  toggle = (on) => {
    this.dispatch(actions.toggleLoadingIndicator(on))
  }
}
